import ContactForm from "../../../widgets/contact-form/ContactForm";
import "./ContactHome.css";
import "./ContactHomeResponsive.css";

function ContactHome() {
  return (
    <div className="row m-0 contact-home">
      <div className="col-lg-6 col-sm-12 col-12 contact-side-panel">
        <div className="contact-home-content-wrapper">
          <div className="header">
            <h3>HAVE ANY QUESTIONS?</h3>
          </div>
          <div className="ed">
            <h1>GET IN-TOUCH</h1>
            <h1>WITH US</h1>
          </div>
        </div>
      </div>
      <div className="col-lg-6 col-sm-12 col-12 contact-form-container">
        <div className="overlay"></div>
        <div className="contact-form-wrapper">
          <h1 className="mobile-contact-form-header">GET IN-TOUCH</h1>
          <ContactForm />
        </div>
      </div>
    </div>
  );
}

export default ContactHome;
